<template>
  <div>
    <iModal
      :title="modelTitle"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
            @submit.native.prevent
          >
            <FormItem label="姓名：" prop="name">
              <Input type="text" v-model="formInline.name" placeholder="请输入姓名" />
            </FormItem>
            <FormItem label="职务：" prop="jobTitle">
              <Input type="text" v-model="formInline.jobTitle" placeholder="请输入职务" />
            </FormItem>
            <FormItem label="类别：" prop="category" :required="true">
              <Select v-model="formInline.category" placeholder="请选择类别">
                <Option v-for="item in linkType" :value="item.name" :key="item.name">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem label="手机：" prop="mobile" :required="true">
              <Input type="text" v-model="formInline.mobile" placeholder="请输入手机" />
            </FormItem>
            <FormItem label="邮箱：" prop="email">
              <Input type="email" v-model="formInline.email" placeholder="请输入邮箱" />
            </FormItem>
            <FormItem label="电话：" prop="tel">
              <Input type="text" v-model="formInline.tel" placeholder="请输入电话" />
            </FormItem>
            <FormItem label="邮寄地址：" prop="Address">
              <Input type="text" v-model="formInline.Address" placeholder="请输入邮寄地址" />
            </FormItem>
            <FormItem label="传真：" prop="fax">
              <Input type="text" v-model="formInline.fax" placeholder="请输入传真" />
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import {  mapGetters } from "vuex";

export default {
  // 新增人员modal
  name: "addOperate",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    modelTitle:{
      type:String,
    },
    options:{
      type:Object,
    },
    linkType:{
      type:Array,
    }
  },
  data() {
    const categoryValid = (rule, value, callback) => {
      if (value && value.length) {
        callback();
      } else {
        callback(new Error("请选择类别"));
      }
    };
    const phoneReg = (rule, value, callback) => {
      if (!value) {
        callback("请输入手机号码");
      } else if (/^[1][0-9]{10}$/.test(value) || value.length == 8 || value.length == 12) {
        callback();
      } else {
        callback("请输入正确的手机号码");
      }
    };
    return {
      loading: false,
      showModal: false,
      showCode: true, // 是否可以获取验证码
      count: "", // 获取验证码的秒数
      formInline: {
        // form双向绑定
        name: "", // 姓名
        jobTitle: "", // 职务
        mobile: "", // 手机
        category:'',
        email:'',
        tel:'',
        fax:'',
        Address:'',
      },
      editId:'',
      ruleInline: {
        // 效验规则
        name: [
          {
            required: true,
            message: "用户为必填选项",
            trigger: "blur",
            type: 'string',
          }
        ],
        jobTitle: [
          {
            required: true,
            message: "职务为必填选项",
            trigger: "blur"
          }
        ],
        category: [
          {
            validator: categoryValid,
            trigger: "change"
          },
          {
            validator: categoryValid,
            trigger: "blur"
          }
        ],
        mobile: [
          { required: true, message: "请输入联系人手机", trigger: "blur" },
          { required: true, validator: phoneReg, trigger: "blur" },
        ],
        email: validator.email,
        tel: [
          {
            required: true,
            message: "必填选项",
            trigger: "blur"
          }
        ],
        Address: [
          {
            required: true,
            message: "必填选项",
            trigger: "blur"
          }
        ],
      }
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
    options(val){
      console.log(val,'options')
      if(val.msg){
        this.formInline.name = val.msg.name;
        this.formInline.jobTitle = val.msg.jobTitle;
        this.formInline.mobile = val.msg.mob;
        this.formInline.category = val.msg.linkType;
        this.formInline.email = val.msg.email;
        this.formInline.tel = val.msg.tel;
        this.formInline.fax = val.msg.fax;
        this.formInline.Address = val.msg.address;
        this.editId = val.msg.id;
      }
    }

  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      joinInfo: "loginModule/getJoinInfo",
      exhibition: "loginModule/getExhibition",
    }),
    exhibitonId() { return this.exhibition.id},
    header() { return this.$store.state.header},
  },
  methods: {
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      this.loading = true;
      // 编辑模式
      if(this.options.model){
        if (this.options.status === 1) {
          this.editLink2(form);
        } else {
          this.editLink(form);
        }
      } else { // 新增模式
        this.addNewLink(form);
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    addNewLink(form){ // 添加联系人
      form.mobile = form.mobile.replace(/^\s+|\s+$/g, '')
      form.email = form.email.replace(/^\s+|\s+$/g, '')
      let body = {
          "ExhibitonId":this.exhibitonId,
          "JoinId":this.joinInfo.joinId,
          "CommandId":1,  // "1：新增，2：修改，3：删除",
          "SetValues":{
            "CompId":this.company.id,
            "Name":form.name,
            "JobTitle":form.jobTitle,
            "Mob":form.mobile,
            "Email":form.email,
            "Tel":form.tel,
            "Fax":form.fax,
            "LinkType":form.category,
            "Address":form.Address,
          }
        }
      this.$http.post('/api/contact',body,this.header)
                .then(res=>{
                  if(res.status === 200 && res.data.successed){
                     this.loading = false;
                     this.$Message.success("添加成功！");
                     this.cancel();
                     this.$emit('addFinsh');
                     this.$emit('linkTo');
                   }else{
                     this.loading = false;
                     this.$Message.error("添加失败，请重新尝试");
                   }
                })
    },
    editLink(form){ // 编辑联系人
      form.mobile = form.mobile.replace(/^\s+|\s+$/g, '')
      form.email = form.email.replace(/^\s+|\s+$/g, '')
        let body = {
          "Id":this.editId,
          "SetValues":{
            "Name":form.name,
            "JobTitle":form.jobTitle,
            "Mob":form.mobile,
            "Email":form.email,
            "Tel":form.tel,
            "Fax":form.fax,
            "LinkType":form.category,
            "Address":form.Address,
          }
        }
        this.$http.put('/api/contactDown',body,this.header)
                .then(res=>{
                  if(res.status === 200 && res.data.successed){
                     this.loading = false;
                     this.$Message.success("修改成功！");
                     this.cancel();
                     this.$emit('addFinsh')
                   }else{
                     this.loading = false;
                     this.$Message.error("修改失败，请重新尝试");
                   }
                })

    },
    editLink2(form){ // 编辑联系人
      form.mobile = form.mobile.replace(/^\s+|\s+$/g, '')
      form.email = form.email.replace(/^\s+|\s+$/g, '')
        let body = {
          "Id":this.editId,
          "JoinId":this.joinInfo.joinId,
          "SetValues":{
            "Name":form.name,
            "JobTitle":form.jobTitle,
            "Mob":form.mobile,
            "Email":form.email,
            "Tel":form.tel,
            "Fax":form.fax,
            "LinkType":form.category,
            "Address":form.Address,
          }
        }
        this.$http.put('/api/contact',body,this.header)
                .then(res=>{
                  if(res.status === 200 && res.data.successed){
                     this.loading = false;
                     this.$Message.success("修改成功！");
                     this.cancel();
                     this.$emit('addFinsh')
                   }else{
                     this.loading = false;
                     this.$Message.error("修改失败，请重新尝试");
                   }
                })

    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

